import { FlaskConical, Plus } from "lucide-react";
import { Button } from "../../../../components/ui/common/button";

interface RecipeListHeaderProps {
  onAddRecipe: () => void;
}

const RecipeListHeader = ({ onAddRecipe }: RecipeListHeaderProps) => (
  <div className="tw-flex tw-items-center tw-justify-between tw-mb-6">
    <div>
      <h1 className="tw-text-2xl tw-font-bold tw-text-foreground tw-flex tw-items-center tw-gap-2">
        <FlaskConical className="tw-h-6 tw-w-6 tw-text-primary" />
        Recipe Simulator
      </h1>
      <p className="tw-text-sm tw-text-muted-foreground tw-mt-1">
        Manage and compare environmental impacts of your product recipes
      </p>
    </div>
    <Button onClick={onAddRecipe} className="tw-gap-2">
      <Plus className="tw-h-4 tw-w-4" />
      New Recipe
    </Button>
  </div>
);

export default RecipeListHeader;
